
import * as React from 'react';


const StraightFace = ({
  style,
  className,
  size = '30px',
  color = '#333' }) => /*#__PURE__*/

React.createElement("svg", {
  fill: "none",
  width: size,
  height: size,
  style: style,
  viewBox: "0 0 30 31",
  className: className,
  xmlns: "http://www.w3.org/2000/svg" }, /*#__PURE__*/

React.createElement("path", {
  d: "M15.5 5.54037C9.75624 5.54037 5.1 10.1966 5.1 15.9404C5.1 21.6841 9.75624 26.3404 15.5 26.3404C21.2438 26.3404 25.9 21.6841 25.9 15.9404C25.9 10.1966 21.2438 5.54037 15.5 5.54037ZM2.5 15.9404C2.5 8.76067 8.3203 2.94037 15.5 2.94037C22.6797 2.94037 28.5 8.76067 28.5 15.9404C28.5 23.1201 22.6797 28.9404 15.5 28.9404C8.3203 28.9404 2.5 23.1201 2.5 15.9404Z",
  fill: color }), /*#__PURE__*/

React.createElement("path", {
  d: "M12.9 12.6904C12.9 13.7673 12.027 14.6404 10.95 14.6404C9.87304 14.6404 9 13.7673 9 12.6904C9 11.6134 9.87304 10.7404 10.95 10.7404C12.027 10.7404 12.9 11.6134 12.9 12.6904Z",
  fill: color }), /*#__PURE__*/

React.createElement("path", {
  d: "M22 12.6904C22 13.7673 21.127 14.6404 20.05 14.6404C18.973 14.6404 18.1 13.7673 18.1 12.6904C18.1 11.6134 18.973 10.7404 20.05 10.7404C21.127 10.7404 22 11.6134 22 12.6904Z",
  fill: color }), /*#__PURE__*/

React.createElement("path", { d: "M20.7 19.8404H10.3V17.2404H20.7V19.8404Z", fill: color }));



export default StraightFace;